import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRecurringJournalsApi,
  saveRecurringJournalApi,
  deleteRecurringJournalApi,
} from "../../apiservice/accounts";

// fetch list
export const fetchRecurringJournals = createAsyncThunk(
  "recurringJournals/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getRecurringJournalsApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// save (create / update)
export const saveRecurringJournal = createAsyncThunk(
  "recurringJournals/save",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveRecurringJournalApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete
export const deleteRecurringJournal = createAsyncThunk(
  "recurringJournals/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteRecurringJournalApi({ id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);